import { render, staticRenderFns } from "./PDFLoader219.vue?vue&type=template&id=5b48721b&scoped=true&"
import script from "./PDFLoader219.vue?vue&type=script&lang=js&"
export * from "./PDFLoader219.vue?vue&type=script&lang=js&"
import style0 from "./PDFLoader219.vue?vue&type=style&index=0&id=5b48721b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b48721b",
  null
  
)

export default component.exports